
import React from 'react';
import AdminLayout from '@/components/admin/AdminLayout';

const EditUserPage: React.FC = () => {
  return (
    <AdminLayout>
      <div className="container py-10">
        <h1 className="text-3xl font-bold">Edit User</h1>
        <p className="mt-4">Edit user profile and settings.</p>
      </div>
    </AdminLayout>
  );
};

export default EditUserPage;
